import Navbar from "@/components/Navbar";
import Mitti from "@/components/Mitti";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import AnimatedBackground from "@/components/AnimatedBackground";

export default function AppsPage() {
  return (
    <>
      <AnimatedBackground />
      <div className="relative" style={{ zIndex: 1 }}>
        <Navbar />
        <Mitti />
        <div className="section-divider" />
        <ContactForm />
        <Footer />
      </div>
    </>
  );
}
